// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"7bd662ad","605":"b2b168ee","809":"62452d41","981":"b9bc3d56"}[chunkId] + ".chunk.js";
};